import React, { useState, useEffect, useContext } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { all_routes } from "../../router/all_routes";
import { useCompanies } from "./useCompanies";
import CompaniesListView from "./companies";
import CompaniesGridView from "./companiesGrid";
import { AuthContext } from "../../../context/authcontext";

type ViewType = "list" | "grid";

const CompaniesContainer = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { selectedTenantId } = useContext(AuthContext);

  const getCurrentView = (): ViewType => {
    return location.pathname.includes("grid") ? "grid" : "list";
  };

  const [currentView, setCurrentView] = useState<ViewType>(getCurrentView());

  const companiesData = useCompanies();

  useEffect(() => {
    setCurrentView(getCurrentView());
  }, [location.pathname]);

  useEffect(() => {
    if (
      selectedTenantId &&
      !companiesData.isInitialized &&
      companiesData.companies.length === 0
    ) {
      companiesData.fetchCompanies(1);
    }
  }, [
    selectedTenantId,
    companiesData.isInitialized,
    companiesData.companies.length,
  ]);

  const handleViewSwitch = (view: ViewType) => {
    const newPath =
      view === "grid" ? all_routes.companiesGrid : all_routes.companies;
    navigate(newPath, { replace: true });
  };

  const sharedProps = {
    ...companiesData,
    currentView,
    onViewSwitch: handleViewSwitch,
  };

  return (
    <>
      {currentView === "list" ? (
        <CompaniesListView {...sharedProps} />
      ) : (
        <CompaniesGridView {...sharedProps} />
      )}
    </>
  );
};

export default CompaniesContainer;
